<div class="reset-container">
  <div class="auth-card">
    <div class="lang-switcher-row">
      <app-language-switcher></app-language-switcher>
    </div>
    <img [src]="brand.logoSrc" class="brand-logo" [alt]="'a11y.logoAlt' | translate" />
    <h2>{{ 'auth.reset.title' | translate }}</h2>

    @if (state === 'checking') {
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      </div>
    } @else if (state === 'invalid') {
      <div class="error">{{ 'auth.reset.invalid' | translate }}</div>
      <a class="primary" [routerLink]="loginUrl">{{ 'auth.reset.backToLogin' | translate }}</a>
    } @else if (state === 'ready') {
      <form (submit)="$event.preventDefault(); submit()">
        <input
          type="password"
          name="password"
          [placeholder]="'auth.reset.newPassword' | translate"
          autocomplete="new-password"
          [(ngModel)]="password"
          [disabled]="busy"
        />
        <input
          type="password"
          name="confirm"
          [placeholder]="'auth.reset.confirmPassword' | translate"
          autocomplete="new-password"
          [(ngModel)]="confirm"
          [disabled]="busy"
        />
        @if (errorMsg) {
          <div class="error">{{ errorMsg }}</div>
        }
        <button type="submit" class="primary" [disabled]="busy">
          {{ (busy ? 'auth.reset.saving' : 'auth.reset.saveBtn') | translate }}
        </button>
      </form>
    }
  </div>
</div>
